/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SetUnhandled$Params {
  raceGuid: string;
  riderGuid: string;
}

export function setUnhandled(http: HttpClient, rootUrl: string, params: SetUnhandled$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setUnhandled.PATH, 'post');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.path('riderGuid', params.riderGuid, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setUnhandled.PATH = '/races/{raceGuid}/riders/{riderGuid}/setunhandled';
